import { isMobile } from 'react-device-detect';
import { className } from '../../../Utils';
import { useLocation } from 'react-router-dom';
import { downClouds } from '../../../Images';

import './CarouselClouds.css';

const CarouselClouds = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    if (!isHomePage) return null;

    return (
        <div className={className('carousel-image-wrapper')}>
            {isMobile ? (
                <div className={className('carousel-image-container-home')}>
                    <img
                        src={downClouds}
                        className={className('carousel-image-container-home-image')}
                        alt="Clouds"
                        loading="lazy"
                    />
                </div>
            ) : (
                <img
                    src={downClouds}
                    className={className('carousel-image-container-pregnancy-desktop')}
                    alt="Clouds"
                    loading="lazy"
                />
            )}
        </div>
    );
};

export default CarouselClouds;
